import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-pl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-pl.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { CreateApplicationDetailsPlConstants } from "./create-application-details-pl.constants";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { take, takeUntil } from "rxjs/operators";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationDetailsPlComponent = class CreateApplicationDetailsPlComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    recipientListService;
    changeDetectorRefs;
    detailsForm;
    validationMessages = CreateApplicationDetailsPlConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    descriptionFormControlName = CreateApplicationDetailsPlConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsPlConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    leaseTypeFormControlName = CreateApplicationDetailsPlConstants.LEASE_TYPE_FORM_CONTROL_NAME;
    leaseReasonFormControlName = CreateApplicationDetailsPlConstants.LEASE_REASON_FORM_CONTROL_NAME;
    leaseUseFormControlName = CreateApplicationDetailsPlConstants.LEASE_USE_FORM_CONTROL_NAME;
    leaseRentalAgreementFormControlName = CreateApplicationDetailsPlConstants.LEASE_RENTAL_AGREEMENT_FORM_CONTROL_NAME;
    leaseStartDateFormControlName = CreateApplicationDetailsPlConstants.LEASE_START_DATE_FORM_CONTROL_NAME;
    leaseEndDateFormControlName = CreateApplicationDetailsPlConstants.LEASE_END_DATE_FORM_CONTROL_NAME;
    lesseeTypeFormControlName = CreateApplicationDetailsPlConstants.LESSEE_TYPE_FORM_CONTROL_NAME;
    lesseeFormControlName = CreateApplicationDetailsPlConstants.LESSEE_FORM_CONTROL_NAME;
    saleAmountFormControlName = CreateApplicationDetailsPlConstants.SALE_AMOUNT_FORM_CONTROL_NAME;
    dateofDeedTransferFormControlName = CreateApplicationDetailsPlConstants.DATE_OF_DEED_TRANSFER_FORM_CONTROL_NAME;
    evaluationAmountFormControlName = CreateApplicationDetailsPlConstants.EVALUATION_AMOUNT_FORM_CONTROL_NAME;
    buyerFormControlName = CreateApplicationDetailsPlConstants.BUYER_FORM_CONTROL_NAME;
    sellerFormControlName = CreateApplicationDetailsPlConstants.SELLER_FORM_CONTROL_NAME;
    saleAmountAlienationFormControlName = CreateApplicationDetailsPlConstants.SALE_AMOUNT_ALIENATION_FORM_CONTROL_NAME;
    dateofDeedAlienationTransferFormControlName = CreateApplicationDetailsPlConstants.DATE_OF_DEED_TRANSFER_ALIENATION_FORM_CONTROL_NAME;
    evaluationAmountAlienationFormControlName = CreateApplicationDetailsPlConstants.EVALUATION_AMOUNT_ALIENATION_FORM_CONTROL_NAME;
    descriptionLabel = CreateApplicationDetailsPlConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = CreateApplicationDetailsPlConstants.APPLICATION_TYPE_LABEL;
    leaseLabel = CreateApplicationDetailsPlConstants.LEASE_LABEL;
    drawPolygonLabel = CreateApplicationDetailsPlConstants.DRAW_POLYGON_LABEL;
    polygonDrawnLabel = CreateApplicationDetailsPlConstants.POLYGON_DRAWN_LABEL;
    leaseTypeLabel = CreateApplicationDetailsPlConstants.LEASE_TYPE_LABEL;
    leaseReasonTypeLabel = CreateApplicationDetailsPlConstants.LEASE_REASON_LABEL;
    leaseUseLabel = CreateApplicationDetailsPlConstants.LEASE_USE_LABEL;
    leaseRentalAgreementLabel = CreateApplicationDetailsPlConstants.LEASE_RENTAL_AGREEMENT_LABEL;
    leaseStartDateLabel = CreateApplicationDetailsPlConstants.LEASE_START_DATE_LABEL;
    leaseEndDateLabel = CreateApplicationDetailsPlConstants.LEASE_END_DATE_FORM_LABEL;
    lesseeLabel = CreateApplicationDetailsPlConstants.LESSEE_LABEL;
    sellerLabel = CreateApplicationDetailsPlConstants.SELLER_LABEL;
    buyerLabel = CreateApplicationDetailsPlConstants.BUYER_LABEL;
    lesseeTypeTypeLabel = CreateApplicationDetailsPlConstants.LESSEE_TYPE_LABEL;
    alienationLabel = CreateApplicationDetailsPlConstants.ALIENATION_LABEL;
    saleAmountLabel = CreateApplicationDetailsPlConstants.SALE_AMOUNT_LABEL;
    dateofDeedTransferLabel = CreateApplicationDetailsPlConstants.DATE_OF_DEED_TRANSFER_LABEL;
    evaluationAmountLabel = CreateApplicationDetailsPlConstants.EVALUATION_AMOUNT_LABEL;
    acquisitionLabel = CreateApplicationDetailsPlConstants.ACQUISITION_LABEL;
    copyApplicantToLesseeLabel = CreateApplicationDetailsPlConstants.COPY_APPLICANT_TO_LESSEE_LABEL;
    copyApplicantToBuyerLabel = CreateApplicationDetailsPlConstants.COPY_APPLICANT_TO_BUYER_LABEL;
    copyApplicantToSellerLabel = CreateApplicationDetailsPlConstants.COPY_APPLICANT_TO_SELLER_LABEL;
    applicationTypes = [];
    leaseTypes = [];
    lesseeTypes = [];
    lesseeDisableFilterBy = true;
    lesseeDisableAdd = false;
    lesseeDisableEditing = false;
    lesseeGroups = [];
    lesseeListLabel = "Lessee";
    buyerDisableFilterBy = true;
    buyerDisableAdd = false;
    buyerDisableEditing = false;
    buyerGroups = [];
    buyerListLabel = "Buyer";
    sellerDisableFilterBy = true;
    sellerDisableAdd = false;
    sellerDisableEditing = false;
    sellerGroups = [];
    sellerListLabel = "Seller";
    leaseAreaDrawn = false;
    constructor(createApplicationService, aflaModuleStrategyService, appController, recipientListService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.recipientListService = recipientListService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        if (this.appController.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.applicationTypes = defaults.propertyLeaseApplicationType;
            this.leaseTypes = defaults.leaseTypes;
            this.lesseeTypes = defaults.lesseeTypes;
            this.lesseeGroups = this.recipientListService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientExternalFilterGroupObjects);
            this.buyerGroups = this.recipientListService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientExternalFilterGroupObjects);
            this.sellerGroups = this.recipientListService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientExternalFilterGroupObjects);
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("applicationTypes")) {
                this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
                this.leaseTypes = this.aflaModuleStrategyService.lookups.get("leaseTypes");
                this.lesseeTypes = this.aflaModuleStrategyService.lookups.get("lesseeTypes");
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
        this.initForm();
        this.leaseAreaDrawn = this.aflaModuleStrategyService.form.get("propertiesForm").get("leaseArea").value !== null;
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    loadMetadata(stepMeta) {
        this.lesseeGroups = stepMeta.lesseeGroup;
        this.buyerGroups = stepMeta.buyerGroup;
        this.sellerGroups = stepMeta.sellerGroup;
    }
    onBtnCopyApplicantToLesseeClicked() {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const lesseeFormControl = this.detailsForm.get("lesseeRecipient");
        this.changeDetectorRefs.detectChanges();
        this.recipientListService.addRecipient(applicant, true, lesseeFormControl, true);
    }
    onBtnCopyApplicantToBuyerClicked() {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const buyerFormControl = this.detailsForm.get("buyerRecipient");
        this.changeDetectorRefs.detectChanges();
        this.recipientListService.addRecipient(applicant, true, buyerFormControl, true);
    }
    onBtnCopyApplicantToSellerClicked() {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const sellerFormControl = this.detailsForm.get("sellerRecipient");
        this.changeDetectorRefs.detectChanges();
        this.recipientListService.addRecipient(applicant, true, sellerFormControl, true);
    }
    applicationTypeChanged() {
        const applicationType = this.aflaModuleStrategyService.form.get("detailsForm").get("applicationType").value.value;
        if (applicationType === "Lease") {
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseType").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseReason").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseUse").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseRentalAgreementAmount").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseStartDate").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseEndDate").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("lesseeType").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("lesseeRecipient").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("saleAmountAlienation").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("dateOfDeedTransferAlienation").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("evaluationAmountAlienation").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("buyerRecipient").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("saleAmount").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("dateOfDeedTransfer").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("evaluationAmount").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("sellerRecipient").disable();
        }
        else if (applicationType === "Alienation") {
            this.aflaModuleStrategyService.form.get("detailsForm").get("saleAmountAlienation").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("dateOfDeedTransferAlienation").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("evaluationAmountAlienation").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("buyerRecipient").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseType").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseReason").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseUse").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseRentalAgreementAmount").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseStartDate").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseEndDate").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("lesseeType").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("lesseeRecipient").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("saleAmount").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("dateOfDeedTransfer").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("evaluationAmount").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("sellerRecipient").disable();
        }
        else if (applicationType === "Acquisition") {
            this.aflaModuleStrategyService.form.get("detailsForm").get("saleAmount").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("dateOfDeedTransfer").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("evaluationAmount").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("sellerRecipient").enable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseType").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseReason").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseUse").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseRentalAgreementAmount").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseStartDate").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("leaseEndDate").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("lesseeType").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("lesseeRecipient").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("saleAmountAlienation").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("dateOfDeedTransferAlienation").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("evaluationAmountAlienation").disable();
            this.aflaModuleStrategyService.form.get("detailsForm").get("buyerRecipient").disable();
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and (name eq 'ApplicationType' or name eq 'LeaseType' or name eq 'LesseeType')`,
        };
        this.createApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsPlConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const leaseTypes = [];
        const lesseeTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === "LeaseType") {
                    leaseTypes.push(JSON.parse(item.content));
                }
                if (item.name === "LesseeType") {
                    lesseeTypes.push(JSON.parse(item.content));
                }
            });
        }
        applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
        leaseTypes.sort((a, b) => a.value.localeCompare(b.value));
        leaseTypes.sort((a, b) => a.value.localeCompare(b.value));
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.applicationTypes = applicationTypes;
        this.aflaModuleStrategyService.lookups.set("leaseTypes", leaseTypes);
        this.leaseTypes = leaseTypes;
        this.aflaModuleStrategyService.lookups.set("lesseeTypes", lesseeTypes);
        this.lesseeTypes = lesseeTypes;
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: RecipientListService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsPlComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-details-pl",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsPlComponent);
export { CreateApplicationDetailsPlComponent };
